// TODO: simplify when module namespaced
export const SHOPPING_CART_CLEAR_STATE = "clearShoppingCartState";

export const ShoppingCartStoreMutations = {
	CLEAR: `${SHOPPING_CART_CLEAR_STATE}`
};
